export default {
  companySelector: {
    label: 'Company',
    placeholder: 'Select a company',
  },
  monthlyActiveReport: {
    title: 'Active Monthly Report',
    cardTitle: 'Filter Information',
    company: 'Company',
    subscriptionType: 'Subscription Type',
    subscriptionTypePlaceholder: 'Select subscription type',
    validity: 'Validity',
    validityPlaceholder: 'Subscription validity status',
    nameOrId: 'Monthly Name or ID',
    monthlyPlate: 'Monthly Plate',
    search: 'Search',
    clean: 'Clear',
    export: 'Export',
    tableTitle: 'Preview Table',
    tableColId: 'Monthly Document',
    tableColName: 'Monthly Name',
    tableColPlate: 'Plate',
    tableColNumOrId: 'Card Number or ID',
    tableColMontlyName: 'Monthly Service',
    tableColslot: 'Slot',
    tableColstartDate: 'Start Date',
    tableColendDate: 'End Date',
    tableColsubscriptionType: 'Subscription Type',
    tableColvehicleType: 'Vehicle Type',
    tableColmonthlyStatus: 'Monthly Status',
    slot: 'Slot',
    slotPlaceholder: 'Select a slot',
  },
}
